import { Box } from '@mui/material';
import MySkeleton from '../../../../components/Skeleton';

const DarkSkeleton = (props: any) => <MySkeleton {...props} bg="#1B1B1B" />;

/** Right side Loader */
export const TasksQuesLoader = () => {
  return (
    <Box className="CardBox" mb={2} p={2}>
      <DarkSkeleton variant="text" height={20} width={150} sx={{ paddingBottom: '10px' }} />
      <DarkSkeleton variant="text" height={20} />
      <DarkSkeleton variant="text" height={20} />

      <DarkSkeleton height="1px" sx={{ margin: '20px 0' }} />

      <DarkSkeleton variant="text" height={20} sx={{ marginBottom: '20px' }} />
      <DarkSkeleton variant="rounded" sx={{ marginBottom: '20px' }} height={'50px'} />

      <DarkSkeleton height="2px" sx={{ margin: '20px 0' }} />

      <DarkSkeleton variant="text" height={20} width={250} sx={{ marginBottom: '10px' }} />
      <DarkSkeleton variant="rounded" sx={{ marginBottom: '10px' }} width={'50%'} height={'50px'} />
      <DarkSkeleton variant="rounded" sx={{ marginBottom: '10px' }} width={'50%'} height={'50px'} />
    </Box>
  );
};

export const MentorLoader = () => (
  <Box className="CardBox" mb={2}>
    <Box my={1} px={2}>
      <DarkSkeleton variant="text" height={20} width={150} />
    </Box>
    <DarkSkeleton height="2px" />
    <Box className="resume-main-sec" justifyContent={'space-between'}>
      {[...Array(3).keys()].map((each, idx) => {
        return (
          <Box display={'flex'} flexDirection={'column'} gap={2} key={idx}>
            <Box display={'flex'} gap={1}>
              <DarkSkeleton variant="circular" height={20} width={20} />
              <DarkSkeleton variant="text" height={20} width={100} />
            </Box>
            <Box display={'flex'} gap={1}>
              <DarkSkeleton variant="rounded" height={60} width={60} />
              <Box>
                <DarkSkeleton variant="text" height={20} width={200} />
                <DarkSkeleton variant="text" height={20} width={200} />
                <DarkSkeleton variant="rounded" height={20} width={100} sx={{ marginTop: '10px' }} />
                <Box display={'flex'} gap={1} mt={2}>
                  <DarkSkeleton variant="rounded" height={32} width={100} />
                  <DarkSkeleton variant="rounded" height={32} width={100} />
                </Box>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  </Box>
);

export const ArticleLoader = () => {
  return (
    <>
      {/* Lesson Materials */}
      <Box className="CardBox" mb={2}>
        <Box my={1} px={2}>
          <DarkSkeleton variant="text" height={20} width={150} />
        </Box>
        <DarkSkeleton height="2px" />
        <Box className="resume-main-sec" gap={3}>
          {[...Array(3).keys()].map((each, idx) => {
            return (
              <Box display={'flex'} gap={2} key={idx}>
                <DarkSkeleton variant="rounded" height={75} width={118} />
                <Box>
                  <DarkSkeleton variant="text" height={24} width={150} />
                  <DarkSkeleton variant="text" height={24} width={150} />
                  <DarkSkeleton variant="text" height={20} width={40} />
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};

/** Left side Loader */
export const TasksLoader = () => {
  return (
    <Box px={2} pb={2} height={'calc(100% - 30px)'} overflow={'auto'}>
      {[...Array(5).keys()].map((each, idx, array) => {
        const isLastItem = idx === array.length - 1;

        return (
          <Box key={idx}>
            <Box display="flex" gap={'8px'} alignItems={'center'} my={2}>
              <Box width={'100%'}>
                <DarkSkeleton width={100} />
                <DarkSkeleton width={200} />
              </Box>
              <DarkSkeleton variant="rounded" width={30} height={30} />
              <Box>
                <DarkSkeleton variant="rectangular" height={20} width={3} />
              </Box>
            </Box>
            <Box mb={{ xs: 1, sm: 2 }} width={'100%'}>
              <Box className="main-banner-sec" width={'100%'} mb={0.5}>
                <DarkSkeleton variant="circular" width={20} height={20} />
                <DarkSkeleton width={'100%'} />
              </Box>
              <DarkSkeleton width={70} />
            </Box>
            {isLastItem ? null : <DarkSkeleton width={'100%'} height={'2px'} />}
          </Box>
        );
      })}
    </Box>
  );
};
